/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_O3Inputs */

const en_mk_sol_startup_o3 = /** @type {(inputs: Mk_Sol_Startup_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The monthly bill stays predictable while the runway is short`)
};

const id_mk_sol_startup_o3 = /** @type {(inputs: Mk_Sol_Startup_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya bulanan tetap bisa diprediksi selagi runway pendek`)
};

/**
* | output |
* | --- |
* | "The monthly bill stays predictable while the runway is short" |
*
* @param {Mk_Sol_Startup_O3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_o3 = /** @type {((inputs?: Mk_Sol_Startup_O3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_O3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_o3(inputs)
	return en_mk_sol_startup_o3(inputs)
});